import { type ReactNode } from "react"
import { modifiers } from "ui-tools"
import { Dialog } from "../Dialog"
import { IconButton } from "../IconButton"
import s from "./Modal.module.scss"

type ModalProps = {
  children: ReactNode
  ariaLabel: string
  onClose: () => void
  overflowAuto?: boolean
  isFullScreenMobile?: boolean
  showCloseButton?: boolean
}
export const Modal = ({
  onClose,
  overflowAuto = true,
  children,
  ariaLabel,
  isFullScreenMobile = false,
  showCloseButton = false,
}: ModalProps) => {
  return (
    <Dialog className={s.modal} ariaLabel={ariaLabel} onClose={onClose}>
      <div
        className={modifiers(s, "modal__content", {
          overflowAuto,
          isFullScreenMobile,
        })}
      >
        {showCloseButton && (
          <IconButton
            as="button"
            className={s.modal__closeButton}
            icon="Close"
            onClick={onClose}
            aria-label="Close"
          />
        )}
        {children}
      </div>
    </Dialog>
  )
}
